export default {
  NAV_FINISHED_STEPS: 'steder fullført',
  ARENA_WHERE_YOU_GO: 'Hvor vil du?',
}
